<template>
  <div class="sortingInfo">
    <!--面包屑-->
    <div class="breadcrumb_box">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in breadcrumbList" :key="index" :to="item.path ? item.path : ''">{{ item.name }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 当前拣货单 -->
    <div class="pickHeader">
      <div class="flex align-items-center justify-content-between">
        <div class="font-size-16 ml10 font-weight-bold">{{ $t('key1004819') }}{{ showNo }} {{ $t('key1000202') }}</div>
        <div class="flex align-items-center">
          <Button
            size="small"
            class="mr20"
            @click="$refs['printingSize'].initPrintingSizeData('sortingPrintSize', sortingPrintSizeObj)">
            {{ $t('key1001280') }}
          </Button>
          <Button size="small" class="mr20" @click="pickFinish">{{ $t('key1004820') }}</Button>
        </div>
      </div>
    </div>
    <!-- content -->
    <Row>
      <Col span="16">
        <!-- 输入sku开始分拣 -->
        <div class="skuInput">
          {{ $t('key1004821') }}
          <Input ref="curSku" :element-id="'skuInputt'" clearable style="width:300px;marginLeft:15px;"
            autofocus @on-enter="clearSku();skuStart()">
          </Input>
        </div>
        <!-- 找篮子及展示货品信息 -->
        <div class="showProductGoods">
          <div v-show="showProductGoods && sku !== null">
            <Row>
              <Col span="15">
                <!-- 拣货框 -->
                <div style="marginLeft:60%;paddingTop:10px;paddingBottom:20px;">
                  <div :style="curBox.color" class="productBox">
                    <span class="font-size-50">{{ curBox.boxNo }}</span>
                  </div>
                </div>
              </Col>
              <Col span="7">
                <!-- 全部分拣完成 -->
                <div v-if="isFinishStatus" style="marginLeft:10%;paddingTop:20px;paddingBottom:20px;width:300px;height:200px;">
                  <div>
                    <Row style="marginBottom:20px;">
                      <Col span="6">
                        <div>
                          <Icon
                            type="md-information-circle"
                            color="#169bd5"
                            style="font-size:40px;marginLeft:20px;lineHeight:20px;"></Icon>
                        </div>
                      </Col>
                      <Col>
                        <h2 style="color:#ff0000;">
                          {{ $t('key1004822') }} </h2>
                      </Col>
                    </Row>
                    <span style="font-size:15px;font-weight:bold;color:#ff0000;">
                      {{ $t('key1004817').replace('{pickingGoodsNo}', showNo) }}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <!-- 货品信息 -->
            <div class="productInfo_box">
              <div>
                <Tooltip placement="left" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                  <img class="img_styles" :src="setImgPath(productGoods.pictureUrl)" @error="setErrorImg($event)" alt=""/>
                  <template #content>
                    <img :ref="'thumbnailImg'" @load="handlerOnloadImg('thumbnailImg')" v-if="productGoods.pictureUrl"
                      :src="setImgPath(productGoods.pictureUrl)" @error="setErrorImg($event)" alt=""/>
                  </template>
                </Tooltip>
              </div>
              <div>
                <div class="font-size-22 mt10 mb10 flex align-items-center">
                  <span>SKU：</span>
                  <span style="color:#008000;">{{ productGoods.sku }}</span>
                </div>
                <div class="font-size-22 mt10 mb10 flex align-items-center">
                  <span>{{ $t('key1002424') }}</span>
                  <span style="color:#008000;">{{ productGoods.title }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 货品异常警告 -->
          <div class="warnBox" v-if="!showProductGoods && sku !== null && sku !== ''">
            <div style="height:25px;background:#dee6ee;padding:5px;border-bottom:1px solid #c5d2e1;">
              {{ $t('key1004823') }}
            </div>
            <div style="width:94%;height:200px;background:#faeed8;border:1px solid #dcddda;marginTop:30px;marginLeft:3%;padding:15px;">
              <h2>
                {{ $t('key1004818').replace('{sku}', sku) }}
              </h2>
              <div style="marginTop:10px;fontSize:14px;">
                <div style="marginBottom:5px;">{{ $t('key1004824') }}</div>
                <span>{{ $t('key1004825') }}</span><br/>
                <span>{{ $t('key1004826') }}</span>
                <div style="marginTop:5px;">{{ $t('key1004827') }}</div>
              </div>
            </div>
            <div class="warnBtn">{{ $t('key1004828') }}</div>
          </div>
        </div>
      </Col>
      <!-- 拣货单及出库单 -->
      <Col span="8">
        <Tabs v-model="tabName" type="card" style="margin:15px 10px 0 10px;" @on-click="changeTab">
          <TabPane name="pickTab" style="height:485px;background-color: rgba(215, 215, 215, 1);" :label="pickTab">
            <h2 style="marginTop:20px;marginBottom:10px;">
              {{ $t('key1004829') }} <span style="color:#0000FF;">{{ showNo }}</span>
            </h2>
            <Table border height="300" :columns="pickGoodsColumn" :data="pickGoodsData"></Table>
          </TabPane>
          <TabPane
            ref="packTab"
            name="packTab"
            style="height:485px;background-color: rgba(215, 215, 215, 1);"
            :label="packTab"
            :disabled="packDisabled">
            <h2 style="marginTop:20px;marginBottom:10px;">
              {{ $t('key1004830') }} <span style="color:#0000FF;">{{ curBox.boxData.packageCode }}</span>
            </h2>
            <div :style="curBox.color" class="showBoxNo">{{ curBox.boxNo }}</div>
            <Table
              highlight-row
              border
              height="300"
              :columns="curPackGoodsTabColumn"
              :data="curBox.boxData.sortingPackageGoodsResult"
              :row-class-name="rowClassName"></Table>
            <Button class="mt30 ml10" v-if="!curBox.replacedOrder" @click="restPackage">{{ $t('key1004831') }}</Button>
            <Button class="mt30 ml10" v-if="!curBox.replacedOrder" @click="removePackage">{{ $t('key1004832') }}</Button>
            <Button class="mt30 ml10" v-if="!curBox.replacedOrder && curBox.boxData.orderType === 'ONE_STOP_SERVICE'"
              @click="printGoodsBarcode">{{ $t('key1004962') }}</Button>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
    <!-- 篮子(包裹) -->
    <div class="pickingGoods">
      <Row>
        <!-- 左 -->
        <Col span="8">
          <template v-for="(item, index) in leftBoxs" v-if="leftBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('leftBoxs', index)" :key="index">
              <div style="border-top: 15px solid #ed4014;border-right: 15px solid transparent;float:left;"></div>
              <div style="text-align:center;marginTop:5px;">
                {{ item.boxNo }}
              </div>
              <div style="text-align:center;marginTop:3px;">
                {{ item.boxData ? item.boxData.packageCode : '' }}
              </div>
            </div>
            <div v-if="(index + 1) % leftCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
        <!-- 中 -->
        <Col span="8" style="borderLeft:5px solid #528ed5;paddingLeft:10px;">
          <template v-for="(item, index) in midBoxs" v-if="midBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('midBoxs',index)" :key="index">
              <div style="border-top: 15px solid #ff9900;border-right: 15px solid transparent;float:left;"></div>
              <div style="text-align:center;marginTop:5px;">
                {{ item.boxNo }}
              </div>
              <div style="text-align:center;marginTop:3px;">
                {{ item.boxData ? item.boxData.packageCode : '' }}
              </div>
            </div>
            <div v-if="(index + 1) % midCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
        <!-- 右 -->
        <Col span="8" style="borderLeft:5px solid #528ed5;paddingLeft:10px;">
          <template v-for="(item, index) in rigBoxs" v-if="rigBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('rigBoxs',index)" :key="index">
              <div style="border-top: 15px solid #2db7f5;border-right: 15px solid transparent;float:left;"></div>
              <div style="text-align:center;marginTop:5px;">
                {{ item.boxNo }}
              </div>
              <div style="text-align:center;marginTop:3px;">
                {{ item.boxData ? item.boxData.packageCode : '' }}
              </div>
            </div>
            <div v-if="(index + 1) % rigCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
      </Row>
    </div>
    <!-- 全部分拣完成模态框 -->
    <!-- <Modal v-model="isFinish" v-if="finModalStatus" width="500" :styles="{top: '200px'}" :mask-closable="false" :closable="false">
      <div slot="header" style="color:#fff">
        <h3>全部分拣完成</h3>
      </div>
      <div>
        <Row>
          <Col span="6">
            <div><Icon type="information-circled" color="#ffcc00" style="font-size:50px;marginLeft:20px;"></Icon></div>
          </Col>
          <Col>
            <span style="font-size:15px;font-weight:bold">{{ '拣货单号：{pickingGoodsNo} 已经分拣完成，点击【结束本次分拣】结束本次作业'.replace('{pickingGoodsNo}', pickingGoodsNo) }}</span>
            <Input v-model.trim="newPickingGoodsNo" style="width:300px;marginTop:20px;" placeholder="扫描/录入拣货单号开始多品分拣" @on-enter="newPickStart"></Input>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button @click="sortingEnd" style="marginRight:200px;">结束分拣</Button>
      </div>
    </Modal> -->
    <!-- 结束分拣有异常弹窗-->
    <endSortingModal ref="endSorting" @endsortingBtn="endsortingBtn"></endSortingModal>
    <!--订单取消提示-->
    <orderCancelPromptModal ref="orderCancelPrompt" @updateData="updateDeliveryData"></orderCancelPromptModal>
    <!--打印配置弹窗-->
    <printingSizeModal ref="printingSize" @updatePrintSet="updatePrintSet"></printingSizeModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import light from "@/components/mixin/sortingInfo_mixin";
import {getErpconfig} from '@/utils/user';
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal";
import endSortingModal from "@/views/yms/components/wms/exWarehouse/endSortingModal.vue";
import printingSizeModal from "@/components/common/printingSizeModal";
import {downloadControl, ymsVerifyPicking, qs, getCommonSetting, getCommonParamKeysData,
  printHtmlUrl, commonLocalStorage} from "@/utils/common";

export default {
  mixins: [Mixin, light],
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004788')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004789')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002652'), path: '/wms/sorting'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004790')}
      ],
      filenodeViewTargetUrl: localStorage.getItem('imgUrlPrefix'),
      pickingGoodsNo: null, // 当前拣货单编号
      sku: null, // 输入sku
      productGoods: {
        // 当前货品展示
        sku: null,
        title: null,
        pictureUrl: null
      },
      showProductGoods: false, // 控制是否显示当前货品信息（无效时用到）
      tabName: 'pickTab', // 控制标签页显示
      pickTab: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004796'),
      packTab: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004797'),
      packDisabled: true, // 控制出库单标签页的显示隐藏
      pickDataNum: 0, // 已完成扫描的货品数量
      leftBoxs: [], // 左侧货架
      midBoxs: [], // 中间货架
      rigBoxs: [], // 右侧货架
      leftRow: null,
      leftCol: null,
      midRow: null,
      midCol: null,
      rigRow: null,
      rigCol: null,
      isFinishStatus: false, // 全部分拣完成提示信息
      isFinish: false, // 分拣完成模态框
      finModalStatus: false, // 是否加载分拣完成模态框
      newPickingGoodsNo: null, // 开启新的拣货单
      curBox: {
        // 当前篮子
        boxData: {}
      },
      packageData: [], // 出库单列表数据
      rowClassIndex: null, // 记录当前高亮行下标
      pickGoodsData: [], // 拣货单货品数据
      pickGoodsColumn: [
        {
          title: 'NO',
          width: 60,
          type: 'index',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004793'),
          key: 'skuInfo',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('div', {class: 'mt5 mb5', style: {color: '#008000'}}, params.row.sku),
              h('div', {class: 'mt5 mb5'}, params.row.title),
              h('div', {class: 'mt5 mb5'}, params.row.variations)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004794'), // 总货品数量
          key: 'quantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004795'), // 已分拣货品数量
          key: 'sortingQuantity',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.haveNum);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003991'), // 还需
          key: 'stillNeed',
          width: 70,
          align: 'center',
          render: (h, params) => {
            let num = params.row.quantity - params.row.haveNum;
            if (num) {
              return h('div', {
                style: {
                  color: '#FF0000'
                }
              }, num);
            } else {
              return h('div', {
                style: {
                  color: '#008000'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554'));
            }
          }
        }
      ],
      curPackGoodsTabColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          type: 'index'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004793'),
          key: 'skuInfo',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('div', {class: 'mt5 mb5', style: {color: '#008000'}}, params.row.sku),
              h('div', {class: 'mt5 mb5'}, params.row.title),
              h('div', {class: 'mt5 mb5'}, params.row.variations)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004957'),
          key: 'quantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004958'),
          key: 'haveSkuNum',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003991'),
          key: 'stillNeed',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            let num = params.row.quantity - params.row.haveSkuNum;
            if (num) {
              return h('div', {
                style: {
                  color: '#FF0000'
                }
              }, num);
            } else {
              return h('div', {
                style: {
                  color: '#008000'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554'));
            }
          }
        }
      ],
      greenLightNum: null, // 记录已经完成分拣的篮子编号
      greenLightStatus: false, // 通过状态判断避免重复调用方法
      showNo: null, // 展示的拣货单号
      leftBoxsStatus: true, // 拣货架状态
      midBoxsStatus: true,
      rigBoxsStatus: true,
      printUrl: '', // 打印地址
      index: 0,
      isPrint: false, // 是否需要打印
      isPrintComplianceLabels: false, // 是否打印商品合规标签
      ymsPickingOrderId: null,
      clearTime: null,
      sortingPrintSizeObj: {},
      aliexpressChoiceTalg: false, // 打印速卖通全托管的标识
      goodsLabelSize: null,
      conventionLabelSize: null,
      logisticsManifestLabelSize: null,
      printParams: null,
      resetYmsPickingOrderRelatedId: null,
    };
  },
  mounted() {
    // 在模态框组件挂载后，监听键盘事件
    document.addEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  created() {
    if (!this.$store.state.erpConfig) {
      getErpconfig();
    }
    this.getSortingPrintSizeData();
    this.startSorting();
  },
  methods: {
    // 开始分拣
    startSorting() {
      let v = this;
      let code = v.$route.query.code;
      v.pickDataNum = 0;
      v.axios.put(api.put_ymsPickingOrder_startSorting + '?code=' + code).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.getPackageSetting(data.ymsWarehouseId);
            if (data.allChangeLable) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004799'));
              setTimeout(() => {
                v.$router.push('/wms/sorting');
              }, 300);
              return false;
            } else {
              v.showNo = data.code;
              let pathlist = [
                {name: data.code}
              ];
              let arr = [...v.breadcrumbList, ...pathlist];
              v.breadcrumbList = v.uniqueFunc(arr, 'name');
              v.ymsPickingOrderId = data.ymsPickingOrderId;
              // 出库单
              let outboundOrder = _getOrderRelatedList(data.ymsPickingOrderRelatedList); // 排除已移除云卖订单
              v.handlerOutboundOrder(outboundOrder).then(() => {
                // 拣货单
                v.handlerPickingListData(outboundOrder);
              });
            }
            // 校验出库单中是否存在有已取消的订单(如果存在取消的订单则弹出取消订单提示窗)
            ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [data.ymsPickingOrderId]).then((list) => {
              if (list.length > 0) {
                this.$refs['orderCancelPrompt'].basicData = list;
                this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
              }
            });
          }
        }
      });

      // 获取正常出库单
      function _getOrderRelatedList(order) {
        let orderList = order || [];
        return orderList.filter(i => i.status === 1);
      }
    },
    // 处理出库单的数据
    handlerOutboundOrder(outboundOrder) {
      let v = this;
      let new_arr = [];
      let ymsPackageGoodList = [];
      if (outboundOrder) {
        return new Promise(resolve => {
          let list = v.handerGrouping(outboundOrder, function (item) {
            return [item.packageCode];
          }, 'packageCode');
          if (list.length > 0) {
            list.map((talg) => {
              ymsPackageGoodList = talg.data[0].ymsPackageInfo.ymsPackageGoods;
              new_arr.push({
                packageCode: talg.data[0].packageCode,
                packageId: talg.data[0].ymsPackageId,
                printTime: talg.data[0].ymsPackageInfo.printTime,
                labelPath: talg.data[0].ymsPackageInfo.labelPath,
                orderType: talg.data[0].ymsPackageInfo.orderType,
                productLabelPath: talg.data[0].productLabelPath || null,
                platformProductLabelPath: talg.data[0].ymsPackageInfo.platformProductLabelPath || null, // 速卖通全托管货品标签面单
                ymsPickingOrderRelatedId: talg.data[0].ymsPickingOrderRelatedId,
                sortingPackageGoodsResult: v.handlerData(ymsPackageGoodList),
                isProductLabelPath: talg.data[0].ymsPackageInfo.isProductLabelPath,
              });
            });
            v.packageData = new_arr;
          }
          resolve();
        });
      }
    },
    // 处理数据
    handlerData(data) {
      let new_arr = [];
      if (data.length > 0) {
        data.map((item) => {
          new_arr.push({
            packageGoodsId: item.ymsPackageGoodsId,
            productGoodsId: item.ymsProductGoodsId,
            quantity: item.quantity,
            sku: item.ymsSku,
            title: item.title,
            variations: item.variations,
            haveSkuNum: 0
          });
        });
        return new_arr;
      }
    },
    // 处理拣货单的数据
    handlerPickingListData(ymsPickingOrderRelatedList, type) {
      let v = this;
      if (ymsPickingOrderRelatedList.length > 0) {
        let pickingList = [];
        ymsPickingOrderRelatedList.forEach((item) => {
          // 已换单之后（包含已换单）排除
          if (item.ymsPackageInfo.status >= 5) {
            _setBox(item.ymsPackageInfo);
            v.packageData.forEach((i, index) => {
              if (i.packageId === item.ymsPackageId) {
                v.packageData.splice(index, 1);
              }
            });
          } else {
            let ymsPackageGoods = item.ymsPackageInfo.ymsPackageGoods;
            if (ymsPackageGoods) {
              pickingList.push(...ymsPackageGoods);
            }
          }
        });
        if (pickingList.length > 0) {
          let new_arr = [];
          const res = new Map();
          let summationList = pickingList.reduce((list, item) => {
            if (res.has(item.ymsProductGoodsId)) {
              res.get(item.ymsProductGoodsId).quantity += item.quantity;
            } else {
              let obj = {...item};
              list.push(obj);
              res.set(item.ymsProductGoodsId, obj);
            }
            return list;
          }, []);
          if (summationList && summationList.length > 0) {
            summationList.map((ele) => {
              new_arr.push({
                haveNum: ele.haveNum || 0, // 拣货单已分拣货品数量
                pickFinishStatus: ele.pickFinishStatus || false, // 拣货单分拣完成状态 false未完成 true已完成
                packageGoodsId: null,
                productGoodsId: ele.ymsProductGoodsId,
                quantity: ele.quantity,
                sku: ele.ymsSku,
                title: ele.title,
                variations: ele.variations,
              });
            });
            if (new_arr.length > 0) {
              v.pickGoodsData = new_arr;
            }
          }
        }
      }

      function _setBox(packageInfo) {
        let isAdd = false;
        [...v.leftBoxs, ...v.midBoxs, ...v.rigBoxs].forEach(box => {
          if (!box.boxIsFinish && !isAdd) {
            isAdd = true;
            box.boxIsFinish = true;
            box.replacedOrder = true; // 表示已换单  隐藏 重置移除
            box.boxData = {
              packageCode: packageInfo.packageCode,
              packageId: packageInfo.ymsPackageId,
              sortingPackageGoodsResult: packageInfo.ymsPackageGoods.map(i => {
                return {
                  haveSkuNum: i.quantity,
                  quantity: i.quantity,
                  sku: i.ymsSku,
                  packageGoodsId: i.ymsPackageGoodsId,
                  productGoodsId: i.ymsProductGoodsId,
                  title: i.title,
                  variations: i.variations
                };
              })
            };
            box.color = 'background:#00B150;cursor:pointer;'; // 绿色
          }
        });
      }
    },
    // 移除已取消的出库单成功之后
    updateDeliveryData(obj) {
      let v = this;
      if (obj) {
        if (obj.allDelete === 1) {
          v.$Modal.info({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004804'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004805'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
            onOk: () => {
              v.$router.push('/wms/sorting');
            }
          });
        } else {
          v.startSorting();
        }
      }
    },
    clearSku() {
      this.sku = this.$refs.curSku.$refs.input.value;
      this.$refs.curSku.$refs.input.value = '';
    },
    // 输入sku开始分拣
    skuStart() {
      let v = this;
      clearTimeout(v.clearTime);
      console.log('输入sku开始分拣:skuStart');
      v.$nextTick(() => {
        v.$refs.curSku.$refs.input.value = '';
      });
      if (this.state === 2) {
        // 先调用方法关掉所有灯
        light.closeAll();
      }
      if (v.greenLightNum !== null && v.greenLightStatus) {
        light.openGreen(v.greenLightNum); // 绿灯常亮 当前篮子已装满
        v.greenLightStatus = false;
      }
      let validObj = v.hasBox();
      if (!validObj.isPickGoods) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004800'));
        v.showProductGoods = false;
        return;
      }
      if (!validObj.hasBox) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004801'));
        return;
      }
      v.showProductGoods = false;
      v.pickGoodsData.forEach((n, i) => {
        if (v.sku === n.sku || v.sku === n.upc) {
          if (n.quantity === n.haveNum) {
            // 判断拣货单中该sku是否已完成分拣
            return false;
          }
          if (n.quantity === n.haveNum + 1) {
            // 记录当前拣货单完成分拣的情况
            console.log('SKU:' + v.sku + '分拣完成');
            v.pickDataNum += 1;
            n.pickFinishStatus = true;
            if (v.pickDataNum === v.pickGoodsData.length) {
              // 全部分拣完毕
              // v.isFinish = true;
              // v.finModalStatus = true;
              v.isFinishStatus = true; // 显示全部完成分拣提示信息
            }
          }
          v.showProductGoods = true;
          v.tabName = 'packTab'; // 若sku有效，显示出库单
          v.packDisabled = false; // 关掉disabled,显示出库单
          v.productGoods = n;
          n.haveNum += 1;
          v.selectBox();
        }
      });
      // 高亮当前行
      let data = v.curBox.boxData.sortingPackageGoodsResult;
      if (data) {
        data.forEach((m, t) => {
          if (m.sku === v.sku || m.upc === v.sku) {
            v.rowClassIndex = t;
          }
        });
      }
    },
    rowClassName(row, index) {
      let v = this;
      if (index === v.rowClassIndex) {
        return 'demo-table-info-row';
      } else {
        return '';
      }
    },
    // 检查是否有没有分配完的出库单
    packageCodeHasSku() {
      let hasTrue = false;
      let v = this;
      [...v.leftBoxs, ...v.midBoxs, ...v.rigBoxs].forEach(i => {
        if (i.boxData && i.boxData.sortingPackageGoodsResult) {
          i.boxData.sortingPackageGoodsResult.forEach(j => {
            if (j.sku === v.sku && j.haveSkuNum < j.quantity) {
              hasTrue = true;
            }
          });
        }
      });
      return hasTrue;
    },
    /**
     * @Description:判断是否有可用拣货篮
     * @date: 2020/11/13 15:20
     * @params:
     */
    hasBox() {
      let hasBox = true;
      let isPickGoods = false; // 是当前拣货单商品
      let firstJoin = false; // 是否第一次拣货
      let v = this;
      v.pickGoodsData.forEach((n, i) => {
        if (v.sku === n.sku || v.sku === n.upc) {
          if (n.haveNum === 0) {
            firstJoin = true;
          }
          isPickGoods = true;
        }
      });
      if (isPickGoods) {
        // 是当前拣货单商品
        // 先判断是否第一次加入
        if (firstJoin) {
          // 判断是否存在在正在拣货的篮子
          if (v.packageCodeHasSku()) {
            hasBox = true;
          } else {
            // 判断是否有空篮子
            hasBox = v.leftBoxs.some(i => i.boxData === null) ||
              v.midBoxs.some(i => i.boxData === null) ||
              v.rigBoxs.some(i => i.boxData === null);
          }
        }
      }
      return {
        hasBox: hasBox,
        isPickGoods: isPickGoods
      };
    },
    selectBox() {
      // 选择符合条件的箱子
      if (!this.findBox(this.leftBoxs)) {
        if (!this.findBox(this.midBoxs)) {
          this.findBox(this.rigBoxs);
        }
      }
    },
    findBox(boxList) {
      // 根据指定的箱子集合查找有效的箱子
      let v = this;
      console.log('-----找篮子:findBox------', boxList);
      if (boxList.length) {
        let isF = false;
        for (let i = 0; i < boxList.length; i++) {
          let box = boxList[i];
          if (box.boxData && !box.boxIsFinish) {
            let sortingPackageGoodsResult = box.boxData.sortingPackageGoodsResult;
            for (let m = 0; m < sortingPackageGoodsResult.length; m++) {
              let k = sortingPackageGoodsResult[m];
              if ((v.sku === k.sku || v.sku === k.upc) && k.haveSkuNum < k.quantity) {
                // 当前篮子需要这个sku
                console.log('box.boxData && !box.boxIsFinish');
                console.log(k);
                isF = true;
                k.haveSkuNum += 1;
                v.curBox = box;
                if (k.quantity === k.haveSkuNum) {
                  console.log('box.boxData && !box.boxIsFinish && k.quantity === k.haveSkuNum');
                  box.packDataNum++;
                  console.log(box.packDataNum);
                  console.log(v.curBox);
                  if (sortingPackageGoodsResult.length === box.packDataNum) {
                    box.color = 'background:#00B150;cursor:pointer;'; // 绿色
                    box.boxIsFinish = true; // 当前篮子已完成分拣
                    // 处理打印
                    v.handlePrinting(box.boxData);
                    if (this.state === 2) {
                      light.flashGreen(box.boxNo); // 绿灯闪烁 当前货品是这个篮子的最后一个
                      v.greenLightNum = box.boxNo;
                      v.greenLightStatus = true;
                    }
                  }
                }
                return true;
              }
            }
          }
        }
        if (isF) return;
        for (let i = 0; i < boxList.length; i++) {
          let box = boxList[i];
          console.log('------box.boxData------', box.boxData);
          if (!box.boxData) {
            // 判断篮子是否为空
            box.boxData = v.getPackageData(box);
            // 已出库处理
            if (box.boxData) {
              box.boxData.sortingPackageGoodsResult.forEach(p => {
                if (p.quantity === 0) {
                  // 都已出库
                  box.packDataNum++;
                }
              });
            }
            box.color = 'background:#9BC053;cursor:pointer;';
            if (this.state === 2) {
              light.flashRed(box.boxNo); // 红灯闪烁 篮子刚分配且当前货品不是最后一个
            }
            // 未完成分拣
            let sortingPackageGoodsResult = box.boxData.sortingPackageGoodsResult;
            for (let m = 0; m < sortingPackageGoodsResult.length; m++) {
              let k = sortingPackageGoodsResult[m];
              if ((v.sku === k.sku || v.sku === k.upc) && k.haveSkuNum < k.quantity) {
                // 当前篮子需要这个sku
                k.haveSkuNum += 1;
                v.curBox = box;
                if (k.quantity === k.haveSkuNum) {
                  box.packDataNum++;
                  if (sortingPackageGoodsResult.length === box.packDataNum) {
                    box.color = 'background:#00B150;cursor:pointer;';
                    box.boxIsFinish = true; // 当前篮子已完成分拣
                    // 处理打印
                    v.handlePrinting(box.boxData);
                    if (this.state === 2) {
                      light.flashGreen(box.boxNo); // 绿灯闪烁 当前货品是这个篮子的最后一个
                      v.greenLightNum = box.boxNo;
                      v.greenLightStatus = true;
                    }
                  }
                }
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    // 获取当前sku的包裹信息
    getPackageData(box) {
      let v = this;
      for (let i = 0; i < v.packageData.length; i++) {
        for (let j = 0; j < v.packageData[i].sortingPackageGoodsResult.length; j++) {
          if (v.sku === v.packageData[i].sortingPackageGoodsResult[j].sku || v.sku === v.packageData[i].sortingPackageGoodsResult[j].upc) {
            let temp = JSON.parse(JSON.stringify(v.packageData[i]));
            box.delPackData = v.packageData.splice(i, 1); // 存起来方便在重置包裹时使用
            console.log('====获取当前sku的包裹信息======', temp);
            return temp;
          }
        }
      }
      return null;
    },
    // 获取分拣架设置列表
    getPackageSetting(ymsWarehouseId) {
      let v = this;
      let query = [
        {
          paramKeys: [
            'enableLeftShelfType', 'enableMidShelfType', 'enableRightShelfType',
            'leftShelfType', 'midShelfType', 'rightShelfType', 'enableSortingPrinted',
            'enableSortingPrintComplianceLabels'
          ],
          businessId: v.userInfo.userId + '*' + ymsWarehouseId
        }
      ];
      getCommonSetting(query).then((data) => {
        if (data) {
          // 获取分拣架状态
          function getPickingStatus(val) {
            let keyList = ['enableLeftShelfType', 'enableMidShelfType', 'enableRightShelfType'];
            let obj = {
              enableLeftShelfType: 'leftBoxsStatus',
              enableMidShelfType: 'midBoxsStatus',
              enableRightShelfType: 'rigBoxsStatus'
            };
            if (keyList.includes(val.paramKey)) {
              v[obj[val.paramKey]] = val.paramValue === 'Y';
            }
          }

          // 获取分拣架的数据
          function getPickingSeting(val) {
            let keyList = ['leftShelfType', 'midShelfType', 'rightShelfType'];
            if (keyList.includes(val.paramKey)) {
              let value = val.paramValue.split('x');
              let obj = {
                leftShelfType: ['leftRow', 'leftCol'],
                midShelfType: ['midRow', 'midCol'],
                rightShelfType: ['rigRow', 'rigCol']
              };
              let statusObj = {
                leftShelfType: v.leftBoxsStatus,
                midShelfType: v.midBoxsStatus,
                rightShelfType: v.rigBoxsStatus
              };
              if (statusObj[val.paramKey]) {
                v[obj[val.paramKey][0]] = value[0];
                v[obj[val.paramKey][1]] = value[1];
              }
            }
          }

          data.forEach((item, i) => {
            getPickingStatus(item);
            getPickingSeting(item);
            // 是否需要打印
            if (item.paramKey === 'enableSortingPrinted') {
              v.isPrint = item.paramValue === 'Y';
            }
            // 分拣时是否打印商品合规标签
            if (item.paramKey === 'enableSortingPrintComplianceLabels') {
              v.isPrintComplianceLabels = item.paramValue === 'Y';
            }
          });
          v.initBox();
        }
      });
    },
    // 初始化拣货框
    initBox() {
      let v = this;
      if (v.leftRow && v.leftCol) {
        for (let i = 1; i <= v.leftRow; i++) {
          for (let j = 1; j <= v.leftCol; j++) {
            let box = {
              boxNo: '1' + i + j,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false // true已完成  false未完成
            };
            v.leftBoxs.push(box);
          }
        }
      }
      if (v.midRow && v.midCol) {
        for (let n = 1; n <= v.midRow; n++) {
          for (let k = 1; k <= v.midCol; k++) {
            let box = {
              boxNo: '2' + n + k,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false
            };
            v.midBoxs.push(box);
          }
        }
      }
      if (v.rigRow && v.rigCol) {
        for (let s = 1; s <= v.rigRow; s++) {
          for (let t = 1; t <= v.rigCol; t++) {
            let box = {
              boxNo: '3' + s + t,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false // 判断篮子是否满了
            };
            v.rigBoxs.push(box);
          }
        }
      }
    },
    print(obj, id, data, orderBy, labelSize) {
      let v = this;
      if (obj) {
        printHtmlUrl(obj, id).then(response => {
          if (response.printType === 'cainiao') {
            v.sortingFinishPrint(data);
            return;
          }
          let jsonObj = response;
          if (jsonObj.content) {
            jsonObj.content = encodeURIComponent(jsonObj.content);
          }
          let originPostId = id;
          let instance = v.axios.create({
            timeout: 3000,
            headers: {
              'Content-Type': 'multipart/form-data; charset=UTF-8'
            }
          });
          // 添加打印尺寸参数
          if (labelSize) {
            jsonObj.labelSize = labelSize;
          }
          delete v.axios.defaults.headers.post['X-Requested-With'];
          instance.post('http://localhost:10099/print', qs(jsonObj)).then(response => {
            if (response.status === 200) {
              // v.sortingFinishPrint(data);
              v.startPrintMonitor(jsonObj, originPostId, data, orderBy);
            }
          }).catch((err) => {
            let fileName = '/tool/TongtoolPrinter.exe';
            downloadControl(fileName).then(() => {
              v.tableLoading = false;
            });
          });
        });
      } else {
        let text = id.includes('HG-') ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004880') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004881');
        v.$Message.error(text);
        return false;
      }
    },
    startPrintMonitor(jsonObj, postId, data, orderBy) {
      let v = this;
      let obj = {
        packageIds: [postId]
      };
      if (orderBy) {
        obj.printOrderBy = orderBy;
      }
      delete jsonObj.content;
      delete v.axios.defaults.headers.post['X-Requested-With'];
      v.axios.jsonp('http://localhost:10099/printResult?' + qs(jsonObj)).then(response => {
        console.log('打印结果集-------', response.data);
        if (response.data === '0') {
          v.clearTime = setTimeout(function () {
            v.$nextTick(() => {
              v.$refs.curSku.$refs.input.value = '';
            });
            v.startPrintMonitor(jsonObj, postId, data, orderBy);
          }, 500);
        } else if (response.data === '2') {
          document.getElementById('skuInputt').focus();
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004806'));
        } else {
          // 不是重复打印，需要调接口
          // 打印合规标签的时候不需要调换单接口，只有打印面单的成功之后才需要调换单接口
          if (!postId.includes('HG-')) {
            v.sortingFinishPrint(data);
          }
        }
      });
    },
    // 标记云卖订单已换单
    sortingFinishPrint(data) {
      let v = this;
      console.log('====分拣打印完成=========');
      v.resetYmsPickingOrderRelatedId = data.ymsPickingOrderRelatedId;
      v.axios.put(api.put_ymsPickingOrderRelated_markChangedLabel, [data.ymsPickingOrderRelatedId]).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004808'));
        }
      });
    },
    // 重置云卖订单已换单
    resetCloudSalesOrderHasBeenChanged(ymsPickingOrderRelatedId) {
      let v = this;
      if (ymsPickingOrderRelatedId) {
        v.axios.put(api.put_ymsPickingOrderRelated_resetChangedLabel, [ymsPickingOrderRelatedId]).then(res => {
          if (res.data.code === 0) {
            v.resetYmsPickingOrderRelatedId = null;
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004959'));
          }
        });
      }
    },
    // 点击侧篮子显示出库单信息
    showBoxInfo(typeData, index) {
      let v = this;
      if (v[typeData][index].boxData) {
        v.curBox = v[typeData][index];
        v.tabName = 'packTab'; // 显示出库单
        v.$forceUpdate();
      }
    },
    // 改变tabName的值
    changeTab(name) {
      let v = this;
      if (name === 'pickTab') {
        v.tabName = 'pickTab';
      } else if (name === 'packTab') {
        v.tabName = 'packTab';
      }
    },
    // 分拣完成 无异常
    sortingEnd() {
      let v = this;
      let obj = {
        ymsPickingOrderRelatedIds: [],
        ymsPickingOrderId: v.ymsPickingOrderId
      };
      v.overSorting(obj);
    },
    // 结束分拣
    overSorting(obj) {
      let v = this;
      // 校验出库单中是否存在有已取消的订单(如果存在取消的订单则弹出取消订单提示窗)
      ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [v.ymsPickingOrderId]).then((list) => {
        if (list.length > 0) {
          v.$refs['orderCancelPrompt'].basicData = list;
          v.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
        } else {
          obj.updateYmsPickingOrderRelatedVos = [];
          obj.insertYmsThirdPackageGoodBos = [];
          v.axios.put(api.put_ymsPickingOrder_endSorting, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              setTimeout(() => {
                v.$router.push('/wms/sorting');
              }, 800);
            }
          });
        }
      });
    },
    // 结束本次分拣
    pickFinish() {
      let v = this;
      let list = []; // 未完成分拣包裹列表
      if (v.packageData.length) {
        // packageData里若是有数据则表示有包裹未分配篮子
        v.packageData.forEach((m, t) => {
          m.noBoxNo = true; // 增加noBoxNo表示该包裹未分配拣货框 true未分配 false已分配
          list.push(m);
        });
      }

      function basketData(item) {
        if (item.boxData) {
          // 先判断篮子是否为空
          if (!item.boxIsFinish) {
            // 判断篮子是否未完成分拣 false未完成 true已完成
            item.noBoxNo = false; // 增加noBoxNo表示该包裹未分配拣货框 true未分配 false已分配
            item.packageId = item.boxData.packageId; // 把id拿到外层，在强制结束用到
            item.packageCode = item.boxData.packageCode; // 把code拿到外层，在异常包裹列表用到
            item.ymsPickingOrderRelatedId = item.boxData.ymsPickingOrderRelatedId;
            list.push(item);
            if (v.state === 2) {
              light.openRed(item.boxNo); // 红灯常亮 还有篮子未分配
            }
          }
        }
      }

      if (v.leftBoxs.length) {
        v.leftBoxs.forEach((item) => {
          basketData(item);
        });
      } else if (v.midBoxs.length) {
        v.midBoxs.forEach((item) => {
          basketData(item);
        });
      } else if (v.rigBoxs.length) {
        v.rigBoxs.forEach((item) => {
          basketData(item);
        });
      }
      let pos = []; // 未完成分拣货品列表
      v.pickGoodsData.forEach((n, i) => {
        if (!n.pickFinishStatus) {
          // 未完成分拣
          pos.push(n);
        }
      });
      if (!list.length && !pos.length) {
        // 当这两个数组都没有数据时，表示无异常
        v.sortingEnd();
      } else {
        // 反正则表示有异常数据
        let nopickData = [];
        list.map((item) => {
          if (!item.printTime || item.boxData.printTime === null) {
            nopickData.push(item);
          }
        });
        v.$refs['endSorting'].initEndSortingData(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004960'), v.showNo, v.ymsPickingOrderId, pos, nopickData, null);
      }
    },
    // 强制结束 有异常
    endsortingBtn(obj) {
      this.overSorting(obj);
    },
    // 将该包裹重置为未开始分拣
    restPackage() {
      let v = this;
      v.sku = null;
      v.$refs.curSku.$refs.input.value = null;
      v.curBox.boxData.sortingPackageGoodsResult.forEach((n, i) => {
        v.pickGoodsData.forEach((m, t) => {
          // m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
          if (((n.sku === m.sku && n.sku) || (n.upc === m.upc && n.upc)) && n.haveSkuNum > 0) {
            m.haveNum -= n.haveSkuNum;
            if (m.pickFinishStatus) {
              v.pickDataNum -= 1;
            }
            m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
          }
        });
      });
      v.curBox.boxData = '';
      v.curBox.boxIsFinish = false; // 把篮子的状态标记为未完成
      v.curBox.packDataNum = 0;
      v.packageData.push(v.curBox.delPackData[0]);
      v.tabName = 'pickTab'; // 显示拣货单
      v.packDisabled = true; // 打开disabled,隐藏出库单
      v.curBox.color = 'background:white';
      v.isFinishStatus = false; // 隐藏全部完成分拣提示信息
      v.resetCloudSalesOrderHasBeenChanged(v.resetYmsPickingOrderRelatedId);
    },
    // 移除包裹的时候是否完成拣货状态
    isPickFinishStatus() {
      this.pickDataNum = 0;
      this.pickGoodsData.forEach(i => {
        if (i.quantity === i.haveNum) {
          i.pickFinishStatus = true;
          this.pickDataNum++;
        }
      });
    },
    // 将该包裹从当前拣货单中移除等待生成新的拣货单
    removePackage() {
      let v = this;
      console.log('_____________---', v.curBox.boxData);
      let ymsPickingOrderRelatedId = v.curBox.boxData.ymsPickingOrderRelatedId;
      v.axios.delete(api.delete_ymsPickingOrderRelated + ymsPickingOrderRelatedId).then(response => {
        if (response.data.code === 0) {
          v.curBox.boxData.sortingPackageGoodsResult.forEach((n, i) => {
            // 先拿到该包裹货品数据
            v.pickGoodsData.forEach((m, t) => {
              // 再从拣货单中删除对应的数量
              if ((n.sku === m.sku && n.sku) || (n.upc === m.upc && m.upc)) {
                if (m.pickFinishStatus) {
                  v.pickDataNum -= 1;
                  m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
                }
                if (m.quantity - n.quantity) {
                  // 拣货单中货品数量减去出库单货品数量，若为0则从拣货单中删除
                  m.haveNum -= n.haveSkuNum;
                  m.quantity -= n.quantity;
                } else {
                  v.pickGoodsData.splice(t, 1);
                }
                v.isPickFinishStatus();
              }
            });
          });
          v.sku = null;
          v.$refs.curSku.$refs.input.value = null;
          v.curBox.boxData = '';
          v.curBox.boxIsFinish = false; // 把篮子的状态标记为未完成
          v.tabName = 'pickTab'; // 显示拣货单
          v.packDisabled = true; // 打开disabled,隐藏出库单
          v.curBox.color = 'background:white';
          v.curBox.packDataNum = 0;
        }
      });
    },
    // 获取打印配置的数据
    getSortingPrintSizeData() {
      let v = this;
      v.sortingPrintSizeObj = {};
      let query = {
        businessId: v.userInfo.userId,
        paramKeys: ['sortingPrintSize']
      };
      getCommonParamKeysData(v.userInfo.userId, ['sortingPrintSize'], false, true).then((data) => {
        if (data && data.length > 0) {
          v.sortingPrintSizeObj = JSON.parse(data[0].paramValue);
        }
      });
    },
    // 更新打印配置数据
    updatePrintSet(obj) {
      this.sortingPrintSizeObj = obj;
    },
    // 处理打印面单
    handlePrinting(data) {
      let v = this;
      v.printParams = data;
      console.log('=======data======', data);
      // 获取设置的打印面单对应的尺寸
      if (Object.keys(v.sortingPrintSizeObj).length > 0) {
        v.goodsLabelSize = `${v.sortingPrintSizeObj.goodsWidth}*${v.sortingPrintSizeObj.goodsHeight}`;
        v.conventionLabelSize = `${v.sortingPrintSizeObj.conventionWidth}*${v.sortingPrintSizeObj.conventionHeight}`;
        v.logisticsManifestLabelSize = `${v.sortingPrintSizeObj.logisticsManifestWidth}*${v.sortingPrintSizeObj.logisticsManifestHeight}`;
      } else {
        v.goodsLabelSize = null;
        v.conventionLabelSize = null;
        v.logisticsManifestLabelSize = null;
      }
      // 判断如果当前的订单类型是速卖通全托管订单，先打印速卖通全托管的货品标签，在打印面单
      if (data.orderType === 'ONE_STOP_SERVICE') {
        v.$Modal.info({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000618'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004879'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
          onOk: () => {
            v.printGoodsLabel();
          }
        });
      } else {
        // 打印商品合规标签
        if (v.isPrintComplianceLabels && data.isProductLabelPath === 1 && v.orderComplianceLabelVerificationTalg) {
          v.print(data.productLabelPath, 'HG-1', data, null, v.goodsLabelSize);
          if (v.isPrint) {
            setTimeout(() => {
              // 打印面单
              v.print(data.labelPath, '1', data, null, v.logisticsManifestLabelSize);
            }, 2000);
          }
        } else {
          if (v.isPrint) {
            v.print(data.labelPath, '1', data, null, v.conventionLabelSize);
          }
        }
      }
    },
    // 监听回车键事件
    handleKeyDown(event) {
      if (event.key === 'Enter' && this.aliexpressChoiceTalg) {
        this.printGoodsLabel();
      }
    },
    // 打印速卖通全托管货品标签面单
    printGoodsLabel() {
      let v = this;
      v.$refs['curSku'].blur();
      v.aliexpressChoiceTalg = true;
      v.print(v.printParams.platformProductLabelPath, 'HG-1', v.printParams, null, v.goodsLabelSize);
      setTimeout(() => {
        v.print(v.printParams.labelPath, '1', v.printParams, null, v.logisticsManifestLabelSize);
      }, 2000);

      setTimeout(() => {
        v.$Modal.remove();
        v.aliexpressChoiceTalg = false;
        document.removeEventListener('keydown', v.handleKeyDown);
      }, 5000);
    },
    // 打印速卖通全托管的货品条码
    printGoodsBarcode() {
      let v = this;
      let data = v.curBox.boxData;
      if (Object.keys(v.sortingPrintSizeObj).length > 0) {
        v.goodsLabelSize = `${v.sortingPrintSizeObj.goodsWidth}*${v.sortingPrintSizeObj.goodsHeight}`;
      }
      if (data) {
        v.print(data.platformProductLabelPath, '1', data, null, v.goodsLabelSize);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004961'));
        return false;
      }
    },
  },
  watch: {
    'curBox': {
      handler(data) {
        if (data) {
          console.log('_____监听当前操作的出库单数据________--', data);
        }
      },
      deep: true
    }
  },
  components: {
    orderCancelPromptModal,
    endSortingModal,
    printingSizeModal
  }
};
</script>

<style lang="less" scoped>
.sortingInfo {
  .breadcrumb_box {
    padding: 12px 0 0 15px;
  }
}

.pickHeader {
  width: 99%;
  height: 40px;
  margin: 10px auto;
  line-height: 40px;
  background-color: rgba(247, 150, 70, 1);
}

.skuInput {
  margin-left: 10px;
  margin-top: 15px;
  padding-left: 10px;
  height: 65px;
  line-height: 65px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background-color: rgba(43, 120, 228, 1);
}

.showProductGoods {
  height: 457px;
  margin-top: 10px;
  padding-top: 20px;
  margin-left: 10px;
  background-color: rgba(215, 215, 215, 1);
}

.pickingGoods {
  width: 99%;
  margin: 10px auto;
}

.pickBox {
  float: left;
  width: 18%;
  height: 50px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #000;
  font-weight: bold;
  margin-right: 2%;
}

.productBox {
  width: 300px;
  height: 170px;
  border: 1px solid #000;
  font-size: 24px;
  text-align: center;
  line-height: 170px;
  font-weight: bold;
}

.productInfo_box {
  width: 96%;
  height: 200px;
  margin: 0 auto;
  padding: 15px 30px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .img_styles {
    vertical-align: middle;
    width: auto;
    max-width: 180px;
    height: 130px;
    cursor: pointer;
    display: inline-block;
    margin-right: 30px;
  }
}

.warnBox {
  width: 80%;
  height: 400px;
  border: 1px solid #717274;
  margin-left: 5%;
  background-color: #fff;
}

.warnBtn {
  width: 200px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  margin-left: 40%;
  background-color: #aaa;
}

.showBoxNo {
  width: 80px;
  height: 40px;
  border: 1px solid #000;
  margin-bottom: 10px;
  text-align: center;
  line-height: 40px;
}
</style>
<style>
.ivu-table .demo-table-info-row td {
  background-color: #ebf7ff;
}
</style>
